function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.769,
  y1: 0.835,
  x2: 0.177,
  y2: 0.205,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#004683",
  stopOpacity: 0.82
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "linear-gradient-2",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#3f74b9"
}), React.createElement("stop", {
  offset: 0.56,
  stopColor: "#349ec7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#2ebbd1"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_7",
  "data-name": "Layer 7",
  transform: "translate(-57.955 -531.5)",
  opacity: 0.9
}, React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(3 -6)"
}, React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z",
  transform: "translate(55.436 537.639)",
  fill: "url(#linear-gradient)"
}), React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M82.944,616.912c0-11.488,14.773-49.19,65.317-54.748",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 9
}), React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z",
  transform: "translate(54.955 537.5)",
  fill: "none"
}), React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(66.6 541.781)"
}, React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 5.467,
  height: 5.467,
  rx: 2.734,
  transform: "translate(112.343 116.515)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M0,130.215Z",
  transform: "translate(0 -23.535)",
  fill: "url(#linear-gradient-2)"
}), React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M134.6,108.079H84.8a20.658,20.658,0,1,0,18.048,30.706h13.7A20.657,20.657,0,1,0,134.6,108.079Z",
  transform: "translate(-20.056 -16.613)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 4.998,
  height: 15.179,
  transform: "translate(62.259 104.767)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  width: 4.998,
  height: 15.179,
  transform: "translate(72.347 109.856) rotate(90)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_4",
  "data-name": "Rectangle 4",
  width: 5.467,
  height: 5.467,
  rx: 2.734,
  transform: "translate(106.875 111.048)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 5.467,
  height: 5.467,
  rx: 2.734,
  transform: "translate(112.343 105.038)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 5.467,
  height: 5.467,
  rx: 2.734,
  transform: "translate(117.81 111.048)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 5.467,
  height: 5.467,
  rx: 2.734,
  transform: "translate(112.343 117.057)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M128.107,91.466s-8.473-10.979-2.506-19.092,0-17.422,0-17.422",
  transform: "translate(-38.61)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 5,
  opacity: 0.99
}))));

var SvgGaming = function SvgGaming(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 200.481,
    height: 200.139,
    viewBox: "0 0 200.481 200.139",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGaming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gaming.59fa0f96.svg";
export { ForwardRef as ReactComponent };